import styled, { css } from 'styled-components';

export const Container = styled.div`
  &.dialog {
    z-index: 100;
    overflow: hidden;

    display: flex;
    justify-content: center;
    align-items: center;

    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    position: fixed;

    ${({ theme }) => css`
      .dialog-overlay {
        position: absolute;
        display: block;

        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        z-index: 0;

        opacity: 0.7;
        background-color: ${theme.colors.black.main};
      }

      .dialog-content {
        z-index: 100;
        width: 100%;
        background-color: red;
        justify-content: center;

        background-color: transparent;
        position: absolute;

        display: flex;
        flex-direction: column;
        align-items: center;

        overflow: auto;
      }
    `}
  }
`;
